import { createContext } from 'react';
import { ApiHandlerState } from './types';

const ApiHandlerContext = createContext<ApiHandlerState>({});

export default ApiHandlerContext;
